import {
  rememberGuestProperty,
  rememberedPropertyId,
  forgetGuestStay,
} from "./guestStay";

/**
 * Property links (`/p/:roomId`) are for manual accounts, which have no
 * bookings. The room id is remembered (see guestStay.js) so a page that loses
 * its route state — a refresh, or the phone discarding or closing the tab —
 * can reopen the property instead of falling back to /go.
 */
const LEGACY_KEY = "propertyLinkId";

export const rememberPropertyLink = (roomId) => {
  rememberGuestProperty(roomId);
};

export const forgetPropertyLink = () => {
  try {
    sessionStorage.removeItem(LEGACY_KEY);
  } catch {
    // Nothing to clear.
  }
  if (rememberedPropertyId()) forgetGuestStay();
};

export const propertyLinkPath = () => {
  let id = rememberedPropertyId();
  if (!id) {
    // Tabs opened before the remembered link moved to localStorage.
    try {
      id = sessionStorage.getItem(LEGACY_KEY);
    } catch {
      id = null;
    }
  }
  return id ? `/p/${encodeURIComponent(id)}` : null;
};

/** True on screens opened from a property link rather than a booking. */
export const isPropertyOnly = (booking) => booking?.propertyOnly === true;
